export { wrapRootElement } from './src/apollo-client.js';
